module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-lg",
      "footer": false
    },
    on: {
      "close": _vm.clearSelectedItem
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("Resource details")]), _vm._v(" "), (_vm.getSelectedItem) ? _c('h3', [_vm._v(_vm._s(_vm.getSelectedItem.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('tabs', [_c('tab', {
    attrs: {
      "name": "Details"
    }
  }, [_c('resource-edit')], 1)], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-336e7fb9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-336e7fb9"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ResourceView.vue
// module id = 1300
// module chunks = 0